import { render, staticRenderFns } from "./ques91.vue?vue&type=template&id=969c8666"
import script from "./ques91.vue?vue&type=script&lang=js"
export * from "./ques91.vue?vue&type=script&lang=js"
import style0 from "./ques91.vue?vue&type=style&index=0&id=969c8666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports